"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiAccountDto = void 0;
const billing_core_account_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-account-type.enum");
const billing_core_external_account_purpose_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-external-account-purpose.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiAccountDto = class BillingApiAccountDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiAccountDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id провайдера",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiAccountDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта счёта",
  format: "^[A-Z]{3}$",
  example: "CRT"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", String)], BillingApiAccountDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Тип счёта. Из API поддерживается создание только счетов типа PERSONAL
    используемых для внутрисайтовой валюты, бонусов и т.д.`,
  example: billing_core_account_type_enum_1.BillingCoreAccountTypeEnum.PERSONAL
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_account_type_enum_1.BillingCoreAccountTypeEnum), __metadata("design:type", String)], BillingApiAccountDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Назначение счёта из классификатора",
  enum: billing_core_account_type_enum_1.BillingCoreAccountTypeEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum), __metadata("design:type", String)], BillingApiAccountDto.prototype, "purpose", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Субсчёт какого счёта",
  format: "uuid",
  type: String,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiAccountDto.prototype, "accountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Связанная со счётом карта, если есть",
  format: "uuid",
  type: String,
  nullable: true,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiAccountDto.prototype, "cardAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Связанный со счётом банк",
  format: "uuid",
  type: String,
  nullable: true,
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiAccountDto.prototype, "bankAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Если у контрагента есть несколько счетов одного типа, то один из этих
    счетов может иметь пометку как счёт по умолчанию`,
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiAccountDto.prototype, "isDefault", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Счёт удалён, после удаления счёт не может использоваться для операций,
    но существующие более ранние операции доступны для отображения`,
  required: false,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiAccountDto.prototype, "deletedAt", void 0);
BillingApiAccountDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiAccountDto);
exports.BillingApiAccountDto = BillingApiAccountDto;
